<template>
  <a-modal
    title="货品补货记录"
    :visible="visible"
    :footer="null"
    width="55%"
    @cancel="handleCancel"
  >
    <a-descriptions bordered :column="2" size="small">
      <a-descriptions-item label="货品名称">
        {{record.goodsName}}
      </a-descriptions-item>
      <a-descriptions-item label="货品编码">
        {{record.shipperGoodsCode}}
      </a-descriptions-item>
      <a-descriptions-item label="货主名称">
        {{record.customerName}}
      </a-descriptions-item>
      <a-descriptions-item label="仓库">
        {{record.warehouseName}}
      </a-descriptions-item>
    </a-descriptions>
    <div class="table-total">
      <a-icon type="info-circle" theme="filled" />
      总计上架数量：{{count}}
    </div>
    <a-table
      :columns="RECORDCOLUMN"
      :data-source="recordList"
      size="middle"
      :scroll="{ x: 'calc(700px + 50%)'}"
      row-key="batchNo"
      :pagination="pagination"
      @change="handleTableChange"
    ></a-table>
  </a-modal>
</template>

<script>
import { RECORDCOLUMN } from '../const'
import { getReplenishmentRecord, getReplenishmentCount } from '../../api'

export default {
  name: 'ReplenishmentRecord',
  data() {
    return {
      visible: false,
      RECORDCOLUMN,
      recordList: [],
      count: 0,
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        onShowSizeChange: (current, pageSize) => {
          this.pageSize = pageSize
        },
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      record: {},
    }
  },
  methods: {
    show(record) {
      this.record = record
      this.visible = true
      this.getRecord()
      this.getCount()
    },
    handleCancel() {
      this.visible = false
    },
    handleTableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
        pageSize: pagination.pageSize,
      }
      this.getRecord()
    },
    async getCount() {
      const { record } = this
      const res = await getReplenishmentCount({
        size: 10,
        from: 0,
        filter: {
          shipperGoodsCode: record.shipperGoodsCode, // 货主货品编码
          customerCode: record.customerCode,  // 客户
          tenantId : record.warehouseId // 公司
        },
        sort: [],
        by_field: [
          'shipperGoodsCode',
          'tenantId',
          'customerCode'
        ],
        "paging": true
      })
      this.count = res.records?.[0]?.cnt || 0
    },
    async getRecord() {
      const { record } = this
      const { current, pageSize } = this.pagination
      const res = await getReplenishmentRecord({
        size: pageSize,
        from: (current - 1)*pageSize,
        filter: {
          shipperGoodsCode: record.shipperGoodsCode, // 货主货品编码
          customerCode: record.customerCode,  // 客户
          tenantId : record.warehouseId // 公司
        },
        sort: [],
        by_field: [],
        paging: true
      })
      this.recordList = res.records
      this.pagination.total = res.total
    }
  }
}
</script>

<style scoped>
.table-total {
  margin: 32px 0 12px 0;
  background: #E6F7F2;
  border-radius: 6px;
  color: #06B880;
  padding: 11px 13px;
}
</style>
